import { lazy } from 'react';

export default {
  path: 'forgotpassword',
  title: 'Forgot Password',
  component: lazy(() => import('./index'))
};
